export default [
  {
    path: '/receipt/:key?',
    name: 'receipt',
    component: () => import('@/views/receipt/ReceiptIndex.vue'),
    meta: {},
  },
];
